"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { toast } from "sonner";
import { FLASH_COOKIE_NAME, type FlashMessage } from "~/lib/flash";
import { z } from "zod";
import { parseJSON } from "~/lib/type-safe-json";
const FlashMessageSchema = z.object({
  type: z.enum(["success", "error", "warning", "info"]),
  message: z.string()
});
export function FlashHandler() {
  const $ = _c(3);
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      if (pathname.startsWith("/api/flash-redirect")) {
        return;
      }
      const cookies = document.cookie.split("; ");
      const flashCookie = cookies.find(_temp);
      if (flashCookie) {
        ;
        try {
          const flashData = parseJSON(decodeURIComponent(flashCookie.split("=")[1]), FlashMessageSchema);
          if (!flashData) {
            return;
          }
          document.cookie = `${FLASH_COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
          setTimeout(() => {
            bb35: switch (flashData.type) {
              case "success":
                {
                  toast.success(flashData.message);
                  break bb35;
                }
              case "error":
                {
                  toast.error(flashData.message);
                  break bb35;
                }
              case "warning":
                {
                  toast.warning(flashData.message);
                  break bb35;
                }
              case "info":
              default:
                {
                  toast.info(flashData.message);
                }
            }
          }, 100);
        } catch (t2) {
          const error = t2;
          console.error("Failed to parse flash message:", error);
        }
      }
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
function _temp(c) {
  return c.startsWith(`${FLASH_COOKIE_NAME}=`);
}